import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Navbar as BsNavbar, Nav, NavDropdown } from 'react-bootstrap';
import { FaBars, FaUser, FaCog, FaSignOutAlt, FaBuilding, FaUsers } from 'react-icons/fa';
import { toggleSidebar } from '../../redux/slices/uiSlice';
import { logout } from '../../redux/slices/authSlice';
import { clearUserState } from '../../redux/slices/userSlice';
import { clearCustomersState } from '../../redux/slices/customersSlice';
import { clearTransactionsState } from '../../redux/slices/transactionsSlice';
import { clearEmployeesState } from '../../redux/slices/employeesSlice';
import styles from './Navbar.module.css';
import config from '../../config';
import { t } from '../../i18n';

const Navbar = ({ selectedMosadCode, isMosadsScreen = false }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const mosads = useSelector(state => state.mosads.mosadsList) || [];
  const user = useSelector(state => state.auth.user);

  const currentMosad = mosads.find(mosad => String(mosad.code) === String(selectedMosadCode));

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  const handleMosadChange = () => {
    dispatch(clearUserState());
    dispatch(clearCustomersState());
    dispatch(clearTransactionsState());
    dispatch(clearEmployeesState());
    localStorage.removeItem(config.APP_NAME + '_mosadToken');
    localStorage.removeItem(config.APP_NAME + '_selectedMosadCode');
    navigate('/mosads');
  };

  if (isMosadsScreen) {
    return (
      <BsNavbar bg="white" expand="lg" className={styles.navbar}>
        <BsNavbar.Brand className={styles.brand}>
          מסבית
        </BsNavbar.Brand>
        <Nav className="ms-auto">
          <NavDropdown
            title={
              <span className={styles.userDropdown}>
                {user?.fullName}
              </span>
            }
            align="end"
          >
            {/*<NavDropdown.Item onClick={() => navigate('/profile')}>
              <FaUser className="me-2" />
              Profile
            </NavDropdown.Item>
             <NavDropdown.Item onClick={() => navigate('/settings')}>
              <FaCog className="me-2" />
              Settings
            </NavDropdown.Item> 
            <NavDropdown.Divider />*/}
            <NavDropdown.Item onClick={handleLogout}>
              <FaSignOutAlt className="me-2" />
              {t('ui.layout.logout')}
            </NavDropdown.Item>
          </NavDropdown>
        </Nav>
      </BsNavbar>
    );
  }

  return (
    <BsNavbar bg="white" expand="lg" className={styles.navbar}>
      <button
        className={styles.sidebarToggle}
        onClick={() => dispatch(toggleSidebar())}
      >
        <FaBars />
      </button>

      <BsNavbar.Toggle />
      <BsNavbar.Collapse>
        <Nav className="me-auto">
          {/* Add any additional nav items here */}
        </Nav>
        
        {/* Center the brand */}
        <div className={styles.centerBrand}>
          <BsNavbar.Brand className={styles.brand}>
            {currentMosad ? currentMosad.name : 'מסבית'}
          </BsNavbar.Brand>
        </div>

        <Nav>
          <NavDropdown
            title={user?.fullName}
            align="end"
            className={styles.userDropdown}
          >
            <NavDropdown.Item onClick={() => navigate('/profile')}>
              <FaUser className="me-2" />
              {t('ui.layout.profile')}
            </NavDropdown.Item>
            {['owner', 'admin'].includes(currentMosad?.role) && (
              <NavDropdown.Item onClick={() => navigate('/employees')}>
                <FaUsers className="me-2" />
                {t('ui.layout.employees')}
              </NavDropdown.Item>
            )}
            <NavDropdown.Item onClick={() => handleMosadChange()}>
              <FaBuilding className="me-2" />
              {t('ui.layout.changeMosad')}
            </NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item onClick={handleLogout}>
              <FaSignOutAlt className="me-2" />
              {t('ui.layout.logout')}
            </NavDropdown.Item>
          </NavDropdown>
        </Nav>
      </BsNavbar.Collapse>
    </BsNavbar>
  );
};

export default Navbar; 